import { useMutation } from '@tanstack/react-query';
import { JsonObject } from 'type-fest';

import type { MutationFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

export type UseUpdateComponentData = {
  id: number;
  parentComponentIds: number[];
} & JsonObject;

export type UseUpdateComponentRequestVars = {
  componentId: number;
  processId?: number | null;
  materialId?: number | null;
  supplierMaterialId?: number | null;
  orientation?: string;
  partNumber?: string | null;
  description?: string | null;
  revision?: string | null;
  isAssembly?: boolean;
  isExportControlled?: boolean;
  shouldKeepExistingOperations?: boolean;
  workflowStatus?: string;
  unitPricePrecision?: number;
};

export const useUpdateComponent: MutationFunction<
  UseUpdateComponentData,
  UseUpdateComponentRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    ({ componentId, ...body }) =>
      request(`/quotes/components/${componentId}`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      }),
    queryOptions,
  );
};
